import { NeighborhoodJob } from 'rwl-shared/dist/models/neighborhood';
import styled from '@emotion/styled';

const Container = styled.div`
    width: 224px;
    height: 100%;
    border-radius: 8px;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
`;

const Title = styled.p`
    margin: 0;
    width: 100%;
    font-weight: 500;
    padding: calc(1.5 * var(--rwl-spacing-sm)) var(--rwl-spacing-md);
    background: white;
    border-bottom-left-radius: var(--rwl-spacing-sm);
    border-bottom-right-radius: var(--rwl-spacing-sm);
`;

const ImageContainer = styled.div`
    display: flex;
    width: 100%;
    height: 136px;
    overflow: hidden;
    border-top-right-radius: var(--rwl-spacing-sm);
    border-top-left-radius: var(--rwl-spacing-sm);
    cursor: pointer;
    background: '#F4F4F4';
`;

const CoverImage = styled.img`
    object-fit: cover;
    flex: 1;
    width: 100%;
    height: 100%;
`;

type JobPopoverProps = {
    job: NeighborhoodJob;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

const JobPopover = ({
    job: { title, coverImageUrl },
    onClick,
    onMouseEnter,
    onMouseLeave,
}: JobPopoverProps) => {
    return (
        <Container onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <ImageContainer onClick={onClick}>
                <CoverImage src={coverImageUrl} loading="lazy" />
            </ImageContainer>
            <Title>{title}</Title>
        </Container>
    );
};

export default JobPopover;
